import { PERMISSION_GROUPS } from '@/constants/constants'
import { useUsersMeRetrieve } from '@api'

export const useRetrieveMe = () => {
  const { data: user, isLoading, error } = useUsersMeRetrieve()

  const canToggleUserAndForwarderView = () => {
    if (!user) return false
    return user.groups?.some(
      (group) =>
        group.name === PERMISSION_GROUPS.PORTRICH ||
        group.name === PERMISSION_GROUPS.PORTRICH_PARTNER,
    )
  }

  const twoLetterCountryCode: string = (user && user.country_code) || ''

  return {
    user,
    twoLetterCountryCode,
    /**
     * ユーザーとフォワーダーのビューを切り替えることができるかどうか.
     * Portrich または Portrich Partner のグループに属している場合に true
     * @returns boolean
     */
    canToggleUserAndForwarderView: canToggleUserAndForwarderView(),
    isLoading,
    error,
  }
}
